import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent } from '@akostm/orbit-ui';
import { IconProp } from '@fortawesome/angular-fontawesome/types';

@Component({
  selector: 'shared-info-and-icon',
  standalone: true,
  imports: [CommonModule, FaIconComponent],
  templateUrl: './info-and-icon.component.html',
  styleUrl: './info-and-icon.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoAndIconComponent {
  icon = input.required<IconProp>();
  infoText = input.required<string>();
}
